<p>vpp-pre-register works!</p>
